module.exports = __webpack_public_path__ + "static/media/qrcode_mini_be.3cebdb03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/qrcode_mini_be.svg
// module id = 1728
// module chunks = 0